import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

// これらのパスプレフィックスではHeader/Footerを非表示にする
const NO_LAYOUT_PREFIXES = ['/admin'];

const Layout = ({ children }) => {
    const location = useLocation();
    const hideLayout = NO_LAYOUT_PREFIXES.some(prefix => location.pathname.startsWith(prefix));

    if (hideLayout) {
        return <>{children}</>;
    }

    return (
        <div>
            <Header />
            <main>
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
